import ToggleMenuField from "../../../components/toggleMenuField/toggleMenuField";
import './menuPanel.scss';
import { MenuPanelProps } from "./types/menuPanelProps";
import { ClassNameNavbar, Option } from "../../../components/shared/navbar/types/navbarProps";
import { ReactComponent as Home } from "../../../icons/home.svg";
import { ReactComponent as ViewList } from "../../../icons/view_list.svg";
import { ReactComponent as DataBase } from "../../../icons/database.svg";
import { ReactComponent as UnreadChat } from "../../../icons/mark_unread_chat_alt.svg";
import { ReactComponent as Dictionaries } from "../../../icons/auto_stories.svg";
import { ReactComponent as Administration } from "../../../icons/business_center.svg";
import Navbar from "../../../components/shared/navbar/navbar";
import { useContext, useEffect, useState } from "react";
import ViewContext from "../../../contexts/viewContext";
import IdleTimerField from "../../../components/idleTimerField/idleTimerField";
import AuthContext from "../../../contexts/authContext";
import PermissionsContext from "../../../contexts/permissionsContext";
import ConfirmModal from "../../../components/modalWindow/confirmModal";
import ViewTaskListContext from "../../../contexts/viewTaskListContext";

const MenuPanel = (props: MenuPanelProps) => {
    const { onlineMode } = useContext(AuthContext);
    const { setViewType, viewTypes, viewType, setKrFormSavePrompt, setKrFormCallback, localView } = useContext(ViewContext);
    const { setViewTaskListType, viewTaskListTypes } = useContext(ViewTaskListContext);
    const { functionsPermissions } = useContext(PermissionsContext);
    const [confirmation, setConfirmation] = useState<boolean>(false);
    const [eventOption, setEventOption] = useState<React.SyntheticEvent<HTMLLIElement> | undefined>(undefined);
    const [navigation, setNavigation] = useState<number| undefined>(undefined);

    const onClickOption = (navigate: number) => {
        return (event: React.SyntheticEvent<HTMLLIElement>) => {
            if((viewType === viewTypes.KRForm || viewType === viewTypes.POForm) && !localView){
                setConfirmation(true);
                setEventOption(event);
                setNavigation(navigate);
            }
            else{
                event.currentTarget.className = "active";
    
                if (shouldResetViewTaskList(navigate, viewType)) {
                    setViewTaskListType(onlineMode ? viewTaskListTypes.TaskListWaiting : viewTaskListTypes.TaskListLocal);
                }
                setViewType(navigate);
            }
        }
    }

    const shouldResetViewTaskList = (nextView: number, prevView: number) => {
        return nextView === viewTypes.TaskList && nextView !== prevView && prevView !== viewTypes.KRForm &&
            prevView !== viewTypes.POForm && prevView !== viewTypes.CollectiveEditForm && prevView !== viewTypes.CollectiveEditFormLocal;
    }

    const ChangeCenterView = () => {
        if(eventOption && navigation){
            //let event = eventOption;
            let navigate = navigation;
            //event.currentTarget.className = "active";

            if (shouldResetViewTaskList(navigate, viewType)) {
                setViewTaskListType(onlineMode ? viewTaskListTypes.TaskListWaiting : viewTaskListTypes.TaskListLocal);
            }
            setViewType(navigate);
        }
    }

    const confirm = () => {
        setKrFormSavePrompt(true);
        setConfirmation(false);
        setKrFormCallback(() => ChangeCenterView);
    }

    const decline = () => {
        setKrFormSavePrompt(false);
        setConfirmation(false);
        ChangeCenterView();
    }

    const cancel = () => {
        setConfirmation(false);
    }

    const getQuestion = () => {
        const question = `Czy zapisać formularz?`;
        return question;
    }

    useEffect(() => {    
        if (!onlineMode) {
            if (viewType === viewTypes.Dictionaries || viewType === viewTypes.Administration || viewType === viewTypes.Communication) {
                setViewType(viewTypes.Home);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onlineMode])

    const iconStyle: React.CSSProperties = { fill: '#453F3A', width: '24px' }

    var hasTaskListView = functionsPermissions.browseUserKRPOWaitingTab.active || functionsPermissions.browseAllKRPOWaitingTab.active || functionsPermissions.browseKRPOInLocalBase.active;
    var hasDictionariesView = functionsPermissions.editDicts.active || functionsPermissions.acceptRejectDictProposals.active;
    var hasAdministrationView = functionsPermissions.configureNotifications.active || functionsPermissions.configurePermissions.active;
    
    var Options: Option[] = [
        { name: 'Strona główna', additionalIcon: Home, onClick: onClickOption(viewTypes.Home), key: viewTypes.Home },
        ...hasTaskListView ? [{ name: 'Lista zadań', additionalIcon: ViewList, onClick: onClickOption(viewTypes.TaskList), key: viewTypes.TaskList }] : [],
        ...functionsPermissions.browseDataBase.active ? [{ name: 'Baza główna', additionalIcon: DataBase, onClick: onClickOption(viewTypes.DataBase), disabled: !onlineMode, key: viewTypes.DataBase }] : [],
        ...functionsPermissions.userNotifications.active ? [{ name: 'Komunikacja', additionalIcon: UnreadChat, onClick: onClickOption(viewTypes.Communication), disabled: !onlineMode, key: viewTypes.Communication }] : [],
        ...hasDictionariesView ? [{ name: 'Słowniki', additionalIcon: Dictionaries, additionalIconStyle: iconStyle, onClick: onClickOption(viewTypes.Dictionaries), disabled: !onlineMode, key: viewTypes.Dictionaries }] : [],
        ...hasAdministrationView ? [{ name: 'Administracja', additionalIcon: Administration, onClick: onClickOption(viewTypes.Administration), disabled: !onlineMode, key: viewTypes.Administration }] : []            
    ]

    const getSelectedTabId = () => {
        return Options.findIndex(item => item.key === viewType) + 1;
    }

    return (
        <div className="menuWrapper">
            <ToggleMenuField setMenuOpened={props.setViewMenu} menuOpened={props.menuOpened} />
            <div className="menuField">
                <Navbar selected={getSelectedTabId()} options={Options} className={ClassNameNavbar.default} spanView={!props.menuOpened}></Navbar>
            </div>
            <IdleTimerField />
            {confirmation && <ConfirmModal width={"660px"} height={"auto"}
                    confirmTitle={"Tak"}
                    onConfirm={confirm}
                    cancelTitle={"Anuluj"}
                    onCancel={cancel}
                    question={getQuestion()}
                    onDecline={decline}
                    declineTitle="Nie"
                />}
        </div>
    )
}

export default MenuPanel;